var extractAttributes = function extractAttributes(source, regex) {
  var extractedAttributes = {};
  var rest = {};
  for (var key in source) {
    if (regex.test(key)) {
      extractedAttributes[key] = source[key];
    } else rest[key] = source[key];
  }
  return {
    extractedAttributes: extractedAttributes,
    rest: rest
  };
};

export { extractAttributes };
//# sourceMappingURL=extractAttributes.js.map
